// Deterministic mock stock dataset for the Stocks module.

import { fetchStockClosingEntriesApi } from "../api/fetchStockClosingEntries";
import { fetchItemBalApi } from "../api/fetchItemBalApi";
import { lastNMonths } from "./mockSales";

/**
 * @typedef {"Beverages" | "Food & Kitchen" | "Wines & Spirits" | "Tobacco" | "Groceries" | "Accessories"} StockCategory
 */

/** @typedef {"MAIN STORE" | "MAIN BAR" | "RESTAURANT" | "PRO SHOP" | "MINI MART"} StockStore */

/** @type {StockStore[]} */
export const STOCK_STORES = [
  "MAIN STORE",
  "MAIN BAR",
  "RESTAURANT",
  "PRO SHOP",
  "MINI MART",
];

/** @type {StockCategory[]} */
export const STOCK_CATEGORIES = [
  "Beverages",
  "Food & Kitchen",
  "Wines & Spirits",
  "Tobacco",
  "Groceries",
  "Accessories",
];

/**
 * @typedef {Object} StockItem
 * @property {number} itemcode
 * @property {string} friendlycode
 * @property {string} salesname
 * @property {number} maincatcode
 * @property {StockCategory} category
 * @property {string} unitmeasure
 * @property {number} purchaseprice
 * @property {number} sellingprice
 * @property {number} minstock
 * @property {number} qty
 * @property {StockStore} store
 * @property {number} storecode
 * @property {number} total_item_qty
 * @property {string} suspended
 */

/**
 * @param {number} seed
 * @returns {() => number}
 */
function seeded(seed) {
  let s = seed;
  return () => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
}

/** @type {Omit<StockItem, "onHand" | "store">[]} */
const BASE_ITEMS = [
  // {
  //   friendlycode: "B001",
  //   salesname: "Tusker Lager 500ml",
  //   category: "Beverages",
  //   unitmeasure: "btl",
  //   purchaseprice: 180,
  //   sellingprice: 250,
  //   minstock: 120,
  // },
  // {
  //   friendlycode: "B002",
  //   salesname: "Pilsner 500ml",
  //   category: "Beverages",
  //   unitmeasure: "btl",
  //   purchaseprice: 175,
  //   sellingprice: 250,
  //   minstock: 96,
  // },
  // {
  //   friendlycode: "B003",
  //   salesname: "Guinness 500ml",
  //   category: "Beverages",
  //   unitmeasure: "btl",
  //   purchaseprice: 230,
  //   sellingprice: 320,
  //   minstock: 96,
  // },
  // {
  //   friendlycode: "B004",
  //   salesname: "Coca-Cola 500ml",
  //   category: "Beverages",
  //   unitmeasure: "btl",
  //   purchaseprice: 45,
  //   sellingprice: 80,
  //   minstock: 144,
  // },
  // {
  //   friendlycode: "B005",
  //   salesname: "Dasani Water 1L",
  //   category: "Beverages",
  //   unitmeasure: "btl",
  //   purchaseprice: 40,
  //   sellingprice: 100,
  //   minstock: 96,
  // },
  // {
  //   friendlycode: "W001",
  //   salesname: "Four Cousins Red 750ml",
  //   category: "Wines & Spirits",
  //   unitmeasure: "btl",
  //   purchaseprice: 850,
  //   sellingprice: 1200,
  //   minstock: 24,
  // },
  // {
  //   friendlycode: "W002",
  //   salesname: "Nederburg White 750ml",
  //   category: "Wines & Spirits",
  //   unitmeasure: "btl",
  //   purchaseprice: 900,
  //   sellingprice: 1300,
  //   minstock: 18,
  // },
  // {
  //   friendlycode: "S001",
  //   salesname: "Gilbey's Gin 750ml",
  //   category: "Wines & Spirits",
  //   unitmeasure: "btl",
  //   purchaseprice: 950,
  //   sellingprice: 1400,
  //   minstock: 24,
  // },
  // {
  //   friendlycode: "S002",
  //   salesname: "Johnnie Walker Black 750ml",
  //   category: "Wines & Spirits",
  //   unitmeasure: "btl",
  //   purchaseprice: 2800,
  //   sellingprice: 4200,
  //   minstock: 12,
  // },
  // {
  //   friendlycode: "F001",
  //   salesname: "Beef (Kg)",
  //   category: "Food & Kitchen",
  //   unitmeasure: "kg",
  //   purchaseprice: 550,
  //   sellingprice: 850,
  //   minstock: 40,
  // },
  // {
  //   friendlycode: "F002",
  //   salesname: "Chicken (Kg)",
  //   category: "Food & Kitchen",
  //   unitmeasure: "kg",
  //   purchaseprice: 380,
  //   sellingprice: 620,
  //   minstock: 30,
  // },
  // {
  //   friendlycode: "F003",
  //   salesname: "Cooking Oil 5L",
  //   category: "Food & Kitchen",
  //   unitmeasure: "jerry",
  //   purchaseprice: 1500,
  //   sellingprice: 1800,
  //   minstock: 12,
  // },
  // {
  //   friendlycode: "F004",
  //   salesname: "Rice 25Kg",
  //   category: "Food & Kitchen",
  //   unitmeasure: "bag",
  //   purchaseprice: 3200,
  //   sellingprice: 3800,
  //   minstock: 8,
  // },
  // {
  //   friendlycode: "T001",
  //   salesname: "SM Cigarettes 20s",
  //   category: "Tobacco",
  //   unitmeasure: "pkt",
  //   purchaseprice: 250,
  //   sellingprice: 320,
  //   minstock: 60,
  // },
  // {
  //   friendlycode: "T002",
  //   salesname: "Dunhill Switch 20s",
  //   category: "Tobacco",
  //   unitmeasure: "pkt",
  //   purchaseprice: 320,
  //   sellingprice: 400,
  //   minstock: 40,
  // },
  // {
  //   friendlycode: "G001",
  //   salesname: "Sugar 2Kg",
  //   category: "Groceries",
  //   unitmeasure: "pkt",
  //   purchaseprice: 260,
  //   sellingprice: 320,
  //   minstock: 40,
  // },
  // {
  //   friendlycode: "G002",
  //   salesname: "Salt 1Kg",
  //   category: "Groceries",
  //   unitmeasure: "pkt",
  //   purchaseprice: 50,
  //   sellingprice: 90,
  //   minstock: 30,
  // },
  // {
  //   friendlycode: "G003",
  //   salesname: "Milk 500ml",
  //   category: "Groceries",
  //   unitmeasure: "pkt",
  //   purchaseprice: 55,
  //   sellingprice: 80,
  //   minstock: 120,
  // },
  // {
  //   friendlycode: "A001",
  //   salesname: "Golf Balls (3-pack)",
  //   category: "Accessories",
  //   unitmeasure: "pack",
  //   purchaseprice: 350,
  //   sellingprice: 500,
  //   minstock: 20,
  // },
  // {
  //   friendlycode: "A002",
  //   salesname: "Golf Tees (pack)",
  //   category: "Accessories",
  //   unitmeasure: "pack",
  //   purchaseprice: 120,
  //   sellingprice: 200,
  //   minstock: 24,
  // },
];

/** @type {StockItem[]} */
export const STOCK_ITEMS = (() => {
  const rand = seeded(31);
  /** @type {StockItem[]} */
  const out = [];
  BASE_ITEMS.forEach((it) => {
    // assign each item to a plausible store
    /** @type {StockStore} */
    const store =
      it.category === "Food & Kitchen"
        ? "RESTAURANT"
        : it.category === "Accessories"
          ? "PRO SHOP"
          : it.category === "Groceries"
            ? "MINI MART"
            : it.category === "Wines & Spirits" || it.category === "Tobacco"
              ? "MAIN BAR"
              : "MAIN STORE";
    const onHand = Math.round(it.minstock * (0.4 + rand() * 2.4));
    out.push({ ...it, store, qty: onHand });
  });
  return out;
})();

/**
 * @typedef {Object} MonthlyStockValue
 * @property {string} month
 * @property {number} opening
 * @property {number} receipts
 * @property {number} issues
 * @property {number} adjustments
 * @property {number} closing
 */

// Monthly opening/closing balances (in KSh value across all stores)
/**
 * @param {number} months
 * @returns {MonthlyStockValue[]}
 */
export function monthlyStockValue(months) {
  const rand = seeded(11);
  const list = lastNMonths(months);
  const totalValue = STOCK_ITEMS.reduce(
    (s, i) => s + i.purchaseprice * i.qty,
    0,
  );
  let l = list.map((m, idx) => {
    const drift = 1 + Math.sin(idx / 3) * 0.06 + idx * 0.008;
    const value = Math.round(totalValue * drift * (0.9 + rand() * 0.2));
    const receipts = Math.round(value * (0.35 + rand() * 0.15));
    const issues = Math.round(value * (0.32 + rand() * 0.15));
    const adjustments = Math.round((rand() - 0.5) * value * 0.03);
    return {
      month: m.label,
      opening: value - receipts + issues,
      receipts,
      issues,
      adjustments,
      closing: value,
    };
  });

  // console.log(l);

  return l;
}

/**
 * @typedef {Object} MonthlyMovement
 * @property {string} month
 * @property {number} purchases
 * @property {number} transfersIn
 * @property {number} transfersOut
 * @property {number} sales
 * @property {number} returns
 */

// Monthly stock movement grouped by type
/**
 * @param {number} months
 * @returns {MonthlyMovement[]}
 */
export function monthlyMovements(months) {
  const rand = seeded(23);
  const list = lastNMonths(months);
  return list.map((m, idx) => ({
    month: m.label,
    purchases: Math.round(1_200_000 * (0.9 + rand() * 0.3) * (1 + idx * 0.01)),
    transfersIn: Math.round(300_000 * (0.7 + rand() * 0.6)),
    transfersOut: Math.round(280_000 * (0.7 + rand() * 0.6)),
    sales: Math.round(1_600_000 * (0.9 + rand() * 0.25) * (1 + idx * 0.012)),
    returns: Math.round(60_000 * (0.5 + rand() * 0.9)),
  }));
}

// Monthly adjustments broken down by reason
/** @type {readonly ["Damage", "Expiry", "Theft", "Count Variance", "Recount"]} */
export const ADJUSTMENT_REASONS = [
  "Damage",
  "Expiry",
  "Theft",
  "Count Variance",
  "Recount",
];

/** @typedef {(typeof ADJUSTMENT_REASONS)[number]} AdjustmentReason */

/**
 * @param {number} months
 * @returns {Record<string, number | string>[]}
 */
export function monthlyAdjustments(months) {
  const rand = seeded(43);
  const list = lastNMonths(months);
  return list.map((m) => {
    /** @type {Record<string, number | string>} */
    const row = { month: m.label };
    ADJUSTMENT_REASONS.forEach((r, i) => {
      const base = [45000, 28000, 12000, 32000, 18000][i];
      row[r] = Math.round(base * (0.6 + rand() * 1.1));
    });
    return row;
  });
}

// Monthly consumption (issues to production/service) per category
/**
 * @param {number} months
 * @returns {Record<string, number | string>[]}
 */
export function monthlyConsumption(months) {
  const rand = seeded(67);
  const list = lastNMonths(months);
  return list.map((m, idx) => {
    const growth = 1 + idx * 0.01;
    /** @type {Record<string, number | string>} */
    const row = { month: m.label };
    STOCK_CATEGORIES.forEach((c, ci) => {
      const base = [180000, 420000, 220000, 60000, 140000, 40000][ci];
      row[c] = Math.round(base * growth * (0.8 + rand() * 0.4));
    });
    return row;
  });
}

/**
 * @typedef {Object} TopConsumedItem
 * @property {string} code
 * @property {string} name
 * @property {StockCategory} category
 * @property {number} qty
 * @property {number} value
 */

// Top consumed items (by cost of goods issued)
/**
 * @param {number} months
 * @returns {TopConsumedItem[]}
 */
export function topConsumedItems(months) {
  const rand = seeded(89);
  return STOCK_ITEMS.map((i) => ({
    code: i.friendlycode,
    name: i.salesname,
    category: i.category,
    qty: Math.round((80 + rand() * 900) * (months / 12)),
    value: 0,
  }))
    .map((r) => {
      const item = /** @type {StockItem} */ (
        STOCK_ITEMS.find((s) => s.friendlycode === r.code)
      );
      return { ...r, value: r.qty * item.purchaseprice };
    })
    .sort((a, b) => b.value - a.value)
    .slice(0, 10);
}

/**
 * @typedef {StockItem & { shortfall: number, status: "Critical" | "Low" | "Watch" }} ReorderAlert
 */

/**
 * @param {StockItem[]} stockItems
 * @returns {ReorderAlert[]}
 */
export function reorderAlerts(stockItems) {
  //console.log(stockItems.length);
  let l = [];
  l = stockItems
    // .slice(0, 5)
    // .filter((i) => i.storecode !== -3)
    .map((i) => ({
      ...i,
      shortfall: Math.max(0, i.minstock - i.qty),
      status: /** @type {"Critical" | "Low" | "Watch"} */ (
        i.qty < i.minstock * 0.5
          ? "Critical"
          : i.qty < i.minstock
            ? "Low"
            : "Watch"
      ),
    }))
    .sort((a, b) => a.qty / a.minstock - b.qty / b.minstock);
  //console.log(l.length);
  return l;
}

/**
 * @typedef {Object} CategoryStockValue
 * @property {string} name
 * @property {number} value
 * @property {number} items
 */

/**
 * @returns {CategoryStockValue[]}
 */
export function stockValueByCategory() {
  return STOCK_CATEGORIES.map((c) => ({
    name: c,
    value: STOCK_ITEMS.filter((i) => i.category === c).reduce(
      (s, i) => s + i.purchaseprice * i.qty,
      0,
    ),
    items: STOCK_ITEMS.filter((i) => i.category === c).length,
  })).sort((a, b) => b.value - a.value);
}

/**
 * @typedef {Object} StoreStockValue
 * @property {string} name
 * @property {number} value
 * @property {number} items
 */

/**
 * @returns {StoreStockValue[]}
 */
export function stockValueByStore() {
  return STOCK_STORES.map((s) => ({
    name: s,
    value: STOCK_ITEMS.filter((i) => i.store === s).reduce(
      (sum, i) => sum + i.purchaseprice * i.qty,
      0,
    ),
    items: STOCK_ITEMS.filter((i) => i.store === s).length,
  }));
}

// real data
/**
 * @returns {Promise<StockItem[]>}
 */
export async function getItemBalance() {
  let b = [];
  // console.log("fetching item bal");

  try {
    const tdy = new Date();
    let endDate = tdy.toLocaleDateString("en-CA");
    b = await fetchItemBalApi(endDate);
  } catch (error) {}

  // console.log(b);

  return b;
}

/**
 * @param {StockItem[]} items
 * @param {number} storeId
 * @param {string} categoryId
 * @param {string} searchTerm
 * @returns {StockItem[]}
 */

export function filterItemsMethod(items, storeId, categoryId, searchTerm) {
  /**@type {StockItem[]} */
  let i = [];
  try {
    i = items.filter((item) => {
      // (storeId === -1 ? true : i.storecode === storeId) &&
      //   (categoryId === "-1" ? true : i.maincatcode === Number(categoryId)),
      const matchesStore = storeId === -1 || item.storecode === Number(storeId);
      const matchesCategory =
        categoryId === "-1" || item.maincatcode === Number(categoryId);
      const containsSearch =
        (item.salesname || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        (item.friendlycode || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase());

      return matchesStore && matchesCategory && containsSearch;
    });
  } catch (error) {}
  // console.log(i);

  return i;
}

/**
 * @param {string} startDate
 * @param {string} endDate
 * @returns {Promise<import("../models/StockClosingModel").StockClosingModel[]>}
 */
export async function getStockClosingEntries({ startDate, endDate }) {
  let b = [];
  const formattedStart = new Date(startDate).toLocaleDateString("en-CA");
  const formattedEnd = new Date(endDate).toLocaleDateString("en-CA");
  try {
    b = await fetchStockClosingEntriesApi(formattedStart, formattedEnd);
  } catch (error) {}

  return b;
}
